/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Overviewliveuntil2Inputs */

const en_overviewliveuntil2 = /** @type {(inputs: Overviewliveuntil2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`until ${i?.time}`)
};

const de_overviewliveuntil2 = /** @type {(inputs: Overviewliveuntil2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`bis ${i?.time}`)
};

/**
* | output |
* | --- |
* | "until {time}" |
*
* @param {Overviewliveuntil2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewliveuntil2 = /** @type {((inputs: Overviewliveuntil2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewliveuntil2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewliveuntil2(inputs)
	return de_overviewliveuntil2(inputs)
});
export { overviewliveuntil2 as "overviewLiveUntil" }